@if (visible) {
  <turbo-frame [id]="frameID"
    [src]="frameURL"
     />
}
